(() => {
  if (window.vtrPdpSpecifications) return;
  window.vtrPdpSpecifications = true;
  const roots = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('[data-vtr-pdp-specifications]').forEach(root => {
      if (roots.has(root)) return;
      const section = root.closest('.shopify-section');
      const selector = section?.querySelector('variant-selection');
      if (!selector) return;
      roots.add(root);
      let controller;
      let generation = 0;
      const cache = new Map();
      if (root.dataset.variantId) cache.set(root.dataset.variantId, { html: root.innerHTML, hidden: root.hidden });
      const refresh = async variant => {
        const id = variant?.id ? String(variant.id) : '';
        if (id === root.dataset.variantId) return;
        const current = ++generation;
        controller?.abort();
        root.dataset.variantId = id;
        root.querySelectorAll('[data-vtr-variant-spec]').forEach(row => row.remove());
        root.hidden = !root.querySelector('dt');
        if (!id) return;
        const apply = data => {
          if (current !== generation || !root.isConnected) return;
          root.innerHTML = data.html;
          root.hidden = data.hidden;
          root.removeAttribute('aria-busy');
        };
        if (cache.has(id)) { apply(cache.get(id)); return; }
        controller = new AbortController();
        root.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(root.dataset.productUrl, window.location.origin);
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          url.searchParams.set('variant', id);
          url.searchParams.set('section_id', root.dataset.sectionId);
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Specification request failed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const updated = [...page.querySelectorAll('[data-vtr-pdp-specifications]')].find(node => node.dataset.productId === root.dataset.productId);
          if (!updated || updated.dataset.variantId !== id) throw new Error('Variant specification mismatch');
          const data = { html: updated.innerHTML, hidden: updated.hidden };
          cache.set(id, data);
          apply(data);
        } catch (error) {
          if (current === generation) {
            root.removeAttribute('aria-busy');
            root.dataset.variantId = '';
          }
        }
      };
      selector.addEventListener('variant-change', event => refresh(event.detail?.variant));
      customElements.whenDefined('variant-selection').then(() => {
        if (typeof selector.getVariant === 'function') selector.getVariant().then(refresh).catch(() => {});
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
